import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myEnterpriseApi } from '../../../api/enterprise/enterprise.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { createEnterpriseMutationService } from './EnterpriseMutationService.impl';

export const myEnterpriseMutationService = createEnterpriseMutationService({
  api: myEnterpriseApi,
  queryClient,
  services: {
    errorService: myErrorService
  }
});
